import React from 'react';
import cn from 'classnames';
import cd from 'debug';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';

import MatchTime from '../MatchTime';
import GameLogo from '../GameLogo';
import globalMessages from 'messages';
import './matchDateTime.scss';

const {
    utils: { formatTimeAndDate },
} = core;

const debug = cd('components:DateTime');

interface Props {
    matchId: string;
    isLive: boolean;
    startTime: string;
    liveCoverage: boolean;
    isSmall: boolean;
    sportId: string;
    showGameLogo?: boolean;
    dateFormat?: string;
}

const MatchDateTime: React.FC<Props> = props => {
    debug('render', props);

    const {
        matchId,
        startTime,
        liveCoverage,
        isLive,
        isSmall,
        sportId,
        showGameLogo,
        dateFormat,
    } = props;

    const { date, time, isToday } = formatTimeAndDate(startTime, {
        // => 01.10 / Oct 01
        dateFormat: dateFormat ? dateFormat : isSmall ? 'dd.MM' : 'MMM dd',
    });

    return (
        <div styleName="container" className="__app-DateTime-container">
            <div styleName="row" className="__app-DateTime-row">
                {showGameLogo && sportId && <GameLogo gameId={sportId} />}
                {(liveCoverage || isLive) && (
                    <div
                        styleName={cn('live', { isLive })}
                        className="__app-DateTime-live"
                    >
                        Live
                    </div>
                )}
            </div>
            <div
                styleName="date"
                className={cn('__app-DateTime-date', {
                    '__app-DateTime-futureDate': !isLive,
                })}
            >
                <div styleName="time-wrapper">
                    {isLive ? (
                        <MatchTime matchId={matchId} sportId={sportId} />
                    ) : (
                        <div styleName="time" className="__app-DateTime-time">
                            {time}
                        </div>
                    )}
                </div>

                {isLive ? null : isToday && !isSmall ? (
                    <div styleName="today">
                        <FormattedMessage {...globalMessages.todayText} />
                    </div>
                ) : (
                    date
                )}
            </div>
        </div>
    );
};

export default MatchDateTime;
